import { assets } from '@/components/virtualPhone/utils';

const lazy = {
  quick: () => assets({ icon: 'mode-quick', dir: '/detect' }),
  simple: () => assets({ icon: 'mode-simple', dir: '/detect' }),
  deep: () => assets({ icon: 'mode-deep', dir: '/detect' }),
  plus: () => assets({ icon: 'mode-plus', dir: '/detect' }),
  btn: () => assets({ icon: 'btn', dir: '/detect' }),
  start: () => assets({ icon: 'start', dir: '/detect' }),
  end: () => assets({ icon: 'end', dir: '/detect' })
};

const r = {};
/**
 * 获取资源 懒加载 缓存
 * @param {keyof lazy} key
 * @returns 返回对应资源
 */
export const get = function (key) {
  if (!r.hasOwnProperty(key) || !r[key]) {
    r[key] = lazy[key]();
  }
  return r[key];
};
